// Videos collected from English-source language-pair searches for
// "good luck" / "good luck!". Lookup is by target language so the
// same clip can play for any source language learning that target.
export type GoodLuckCelebrationVideo = {
  src: string;
  phrase: string;
  translation: string;
};

const GOOD_LUCK_VIDEOS: Record<string, GoodLuckCelebrationVideo[]> = {
  ar: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ12025_AR_YARA_F_72082_b9447cd7__72082__f_normalized.mp4',
      phrase: 'حظاً سعيداً!',
      translation: 'Good luck!',
    },
  ],
  da: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000127216_170202_1300_54.mp4',
      phrase: 'Held og lykke!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000127216_170202_1301_01.mp4',
      phrase: 'Held og lykke!',
      translation: 'Good luck!',
    },
  ],
  de: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_DE_SANJA_F_172219_8cca3889__172219__f_normalized.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/94755__f__1533832993.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/94755__f__1533893819.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/94755__f__1533899490_normalized.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/94755__m__1533893009_normalized.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/94755__m__1533898124.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/94755__m__1533899181.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000077623_161028_1501_53.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000077623_161028_1501_59.mp4',
      phrase: 'Viel Glück!',
      translation: 'Good luck!',
    },
  ],
  el: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ12024_EL_ALEX_M_192675_8bc86109__192675__m_normalized.mp4',
      phrase: 'Καλή επιτυχία!',
      translation: 'Good luck!',
    },
  ],
  en: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/89167__m__1533425478.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/89167__f__1533748211.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/89167__f__1533413918.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/89167__f__1533762946.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/89167__m__1533747052.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000000196_170228_1520_52.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000000196_170228_1521_25.mp4',
      phrase: 'Good luck!',
      translation: 'Good luck!',
    },
  ],
  es: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95697__f__1534355226.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95697__f__1534742330.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95697__m__1534315327.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95697__f__1535096390.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95697__m__1534916344.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/2/videos/%C2%A1buena+suerte%21/medium/1.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000039503_170201_1239_03.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000039503_170201_1239_11.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
  ],
  'es-mx': [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/AV_ALX22MX01_JUAN_35_249f6b73__117638__m.mp4',
      phrase: '¡Suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22MX01_ALE5E23_117638_2_f1d2359a__117638__f_normalized.mp4',
      phrase: '¡Suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22MX01_ALE5E23_117638_3_138c36f1__117638__f_normalized.mp4',
      phrase: '¡Suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/56181__f__1536641620.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/56181__m__1536499326.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/56181__f__1536687357.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/56181__f__1536500196.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/56181__m__1536641463.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/56181__m__1536687450.mp4',
      phrase: '¡Buena suerte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/19094HOLI_ESMX191210SD2_C12_A1_L506_2_11HD_861de27f__114099__f.mp4',
      phrase: '¡Chones amarillos para la buena suerte!',
      translation: 'Yellow pants to bring good luck!',
    },
  ],
  fa: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ22024_FA_HAMED_M_240175_acd6f6f7__240175__m.mp4',
      phrase: 'موفق باشی!',
      translation: 'Good luck!',
    },
  ],
  fr: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/86654__f__1528366257_normalized.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/86654__f__1528458964_normalized.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/86654__m__1528463972_normalized.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/86654__m__1528467443.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/86654__m__1528469401.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/86654__m__1528476073.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000091404_161025_1336_57_normalized.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000091404_161025_1617_14.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000091404_161025_1621_59.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000091404_161117_1630_34_normalized.mp4',
      phrase: 'Bonne chance!',
      translation: 'Good luck!',
    },
  ],
  gl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/IAV_IMQ22024_GL_ESTEFANIA_F_248438_69d35a69.mp4',
      phrase: 'Moita sorte!',
      translation: 'Good luck!',
    },
  ],
  ha: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_HA_KABIRU_M_266369_6020a976__266369__m_normalized.mp4',
      phrase: "sa'a mai kyau",
      translation: 'Good luck!',
    },
  ],
  id: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ12024_ID_AILA_F_191737_eabae3a5__191737__f.mp4',
      phrase: 'Semoga sukses!',
      translation: 'Good luck!',
    },
  ],
  ig: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_IG_CHIKWADOROM_M_262124_fefd7dce__262124__m_normalized.mp4',
      phrase: 'Ihu ọma kpọọ gị!',
      translation: 'Good luck!',
    },
  ],
  is: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32024_IS_FLEMMING_F_250265_9fb5cdde__250265__f_normalized.mp4',
      phrase: 'Gangi þér vel!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32024_IS_FLEMMING_F_250265_d728c090__250265__f_normalized.mp4',
      phrase: 'Gangi þér vel!',
      translation: 'Good luck!',
    },
  ],
  it: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93355__f__1533831957_normalized.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93355__f__1533915146.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93355__f__1534245480_normalized.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93355__m__1533912222_normalized.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93355__m__1533914989_normalized.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93355__m__1534350245_normalized.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/6/videos/buona+fortuna%21/medium/1.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000107789_170221_1308_36.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000107789_170221_1308_47.mp4',
      phrase: 'Buona fortuna!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93302__f__1533740278_normalized.mp4',
      phrase: 'In bocca al lupo!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93302__f__1533831963_normalized.mp4',
      phrase: 'In bocca al lupo!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93302__f__1534245475.mp4',
      phrase: 'In bocca al lupo!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93302__f__1534770269_normalized.mp4',
      phrase: 'In bocca al lupo!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93302__m__1533740466_normalized.mp4',
      phrase: 'In bocca al lupo!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93302__m__1533912227_normalized.mp4',
      phrase: 'In bocca al lupo!',
      translation: 'Good luck!',
    },
  ],
  'jp-full': [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000412419_161202_1147_58.mp4',
      phrase: '頑張れ！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532506135_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532616974.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532617066.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532804121_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1533122456_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__m__1532433673_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__m__1532551664.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__m__1532637676_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161108_1617_57.mp4',
      phrase: '幸運を祈ります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161111_1249_40.mp4',
      phrase: '幸運を祈ります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161220_1711_03.mp4',
      phrase: '幸運を祈ります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161108_1617_57.mp4',
      phrase: 'こううんをいのります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161111_1249_40.mp4',
      phrase: 'こううんをいのります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161220_1711_03.mp4',
      phrase: 'こううんをいのります！',
      translation: 'Good luck!',
    },
  ],
  'jp-romaji': [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000412419_161202_1147_58.mp4',
      phrase: '頑張れ！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532506135_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532616974.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532617066.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1532804121_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__f__1533122456_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__m__1532433673_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__m__1532551664.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/88264__m__1532637676_normalized.mp4',
      phrase: 'がんばって！',
      translation: 'Hang in there!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161108_1617_57.mp4',
      phrase: '幸運を祈ります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161111_1249_40.mp4',
      phrase: '幸運を祈ります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161220_1711_03.mp4',
      phrase: '幸運を祈ります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161108_1617_57.mp4',
      phrase: 'こううんをいのります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161111_1249_40.mp4',
      phrase: 'こううんをいのります！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000139121_161220_1711_03.mp4',
      phrase: 'こううんをいのります！',
      translation: 'Good luck!',
    },
  ],
  ko: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000236512_170206_1420_00.mp4',
      phrase: '행운을 빌어요！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000236512_170206_1420_15.mp4',
      phrase: '행운을 빌어요！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000236512_170206_1420_30.mp4',
      phrase: '행운을 빌어요！',
      translation: 'Good luck!',
    },
  ],
  mn: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ22025_MN_BOLO_F_274432_cd573014__274432__f_normalized.mp4',
      phrase: 'Амжилт!',
      translation: 'Good luck!',
    },
  ],
  nl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_NL_REMON_M_20631_efdf05a8__20631__m_normalized.mp4',
      phrase: 'Succes!',
      translation: 'Good luck!',
    },
  ],
  no: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136228_170216_1357_20.mp4',
      phrase: 'Lykke til!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136228_170216_1357_40.mp4',
      phrase: 'Lykke til!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136228_170216_1357_54.mp4',
      phrase: 'Lykke til!',
      translation: 'Good luck!',
    },
  ],
  pl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_Q42024_PL_Pawel_M_65610_b4c6c6e8__65610__m_normalized.mp4',
      phrase: 'Baw się dobrze!',
      translation: 'Have a good time!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_PL_MACIEK_M_64322_b534e127__64322__m_normalized.mp4',
      phrase: 'Czy są państwo gotowi?',
      translation: 'Are you ready?',
    },
  ],
  pt: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/1%20%286%29_4da8792d__115472__m.mp4',
      phrase: 'Boa sorte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/1000113616_170227_2214_19_f92e1024__115472__f.mp4',
      phrase: 'Boa sorte!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/1000113616_170227_2215_41_94ced73d__115472__f_normalized.mp4',
      phrase: 'Boa sorte!',
      translation: 'Good luck!',
    },
  ],
  'pt-br': [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_BR_ADRIANO_M_26747_4dcd32b9__26747__m_normalized.mp4',
      phrase: 'Boa sorte!',
      translation: 'Good luck!',
    },
  ],
  ru: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/RUSSIA_CARD1_20181001_043_06_9dcfd53c__99431__m.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/RUSSIA_CARD1_20181001_044_03_6d0edaa3__99431__f_normalized.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/RUSSIA_CARD1_20181002_0025_13_77d321d3__99431__m.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/RUSSIA_CARD1_20181002_0026_17_1a9a264b__99431__f.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/RUSSIA_CARD2_20181003_0001_15_9bb1efc7__99431__f.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/RUSSIA_CARD2_20181003_0002_15_NEW_0f6ca816__99431__m.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000119314_161031_1547_23.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000119314_161031_1547_34.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000119314_161031_1547_45.mp4',
      phrase: 'Удачи!',
      translation: 'Good luck!',
    },
  ],
  sl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98500__f__1537478658.mp4',
      phrase: 'Srečno!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98500__m__1537553975.mp4',
      phrase: 'Srečno!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98500__f__1537481335.mp4',
      phrase: 'Srečno!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98500__m__1537554370.mp4',
      phrase: 'Srečno!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98500__m__1537476385.mp4',
      phrase: 'Srečno!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98500__f__1537555649.mp4',
      phrase: 'Srečno!',
      translation: 'Good luck!',
    },
  ],
  so: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_SO_MOHAMED_M_261242_836a547b__261242__m_normalized.mp4',
      phrase: 'Nasiib-wacan!',
      translation: 'Good luck!',
    },
  ],
  sv: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133476_170219_1225_41.mp4',
      phrase: 'Lycka till!',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133476_170219_1225_52.mp4',
      phrase: 'Lycka till!',
      translation: 'Good luck!',
    },
  ],
  sw: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ22024_SW_RAIKANYA_M_229629_1adcd343__229629__m_normalized.mp4',
      phrase: 'Bahati nzuri!',
      translation: 'Good luck!',
    },
  ],
  th: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_TH_SAVI_F_216152_cd7bb2cd__216152__f_normalized.mp4',
      phrase: 'โชคดีนะ!',
      translation: 'Good luck!',
    },
  ],
  tr: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_TR_FATMA_F_32714_1d44c71a__32714__f_normalized.mp4',
      phrase: 'İyi şanslar!',
      translation: 'Good luck!',
    },
  ],
  uk: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ22024_UK_ALEXANDER_M_215065_50ff6595__215065__m_normalized.mp4',
      phrase: 'Удачі!',
      translation: 'Good luck!',
    },
  ],
  yo: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_YO_IBU_M_265806_8d24b972__265806__m_normalized.mp4',
      phrase: 'Ṣé ẹ ti ṣetán?',
      translation: 'Are you ready?',
    },
  ],
  'zh-cn': [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133153_161125_1637_19.mp4',
      phrase: '加油！',
      translation: 'Come on!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133153_161130_1549_34.mp4',
      phrase: '加油！',
      translation: 'Come on!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133153_161206_1324_49.mp4',
      phrase: '加油！',
      translation: 'Come on!; good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000132537_161125_1205_12.mp4',
      phrase: '祝你好运！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000132537_161129_1734_05.mp4',
      phrase: '祝你好运！',
      translation: 'Good luck!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000132537_161205_1444_17.mp4',
      phrase: '祝你好运！',
      translation: 'Good luck!',
    },
  ],
};

export const GOOD_LUCK_CELEBRATION_LOCALES = Object.keys(GOOD_LUCK_VIDEOS);

const LOCALE_ALIASES: Record<string, string> = {
  'es-es': 'es',
  'pt-pt': 'pt',
  nb: 'no',
  nn: 'no',
};

export const getGoodLuckCelebrationVideos = (
  locale?: string | null,
): GoodLuckCelebrationVideo[] => {
  if (!locale) {
    return [];
  }

  const normalized = locale.trim().toLowerCase();
  const aliased = LOCALE_ALIASES[normalized] ?? normalized;
  return GOOD_LUCK_VIDEOS[aliased] ?? GOOD_LUCK_VIDEOS[aliased.split('-')[0]] ?? [];
};

export const pickGoodLuckCelebrationVideo = (
  locale?: string | null,
  random: () => number = Math.random,
): GoodLuckCelebrationVideo | undefined => {
  const videos = getGoodLuckCelebrationVideos(locale);
  if (videos.length === 0) {
    return undefined;
  }

  return videos[Math.floor(random() * videos.length)];
};
